export default __webpack_public_path__ + "static/Pagarme_Antifraude-33a0bae2598868ae1ae09c768942a17b.png";